import {
  ErrorMessage,
  Field,
  type FormikErrors,
  type FormikTouched,
  type FormikValues,
} from 'formik';
import * as React from 'react';
import './input-field.scss';

interface InputFieldInterface {
  name: string;
  as?: string;
  type?: string;
  accept?: string;
  id?: string;
  errors?: FormikErrors<FormikValues>;
  touched?: FormikTouched<FormikValues>;
  placeholder?: string;
  disabled?: string;
  className?: string;
  rows?: number;
}

export const InputField = (props: InputFieldInterface): React.ReactElement => {
  const {
    accept,
    as,
    rows,
    id,
    errors,
    touched,
    name,
    type,
    disabled,
    placeholder,
    className,
  } = props;
  const hasError = id && touched?.[id] && errors?.[id];

  return (
    <div className="Input__Field__Wrapper">
      <Field
        accept={accept}
        as={as}
        className={`${className} Input__Field form-control ${
          hasError ? 'is-invalid' : ''
        }`}
        disabled={disabled}
        id={id as string}
        name={name}
        placeholder={placeholder}
        rows={rows}
        type={type}
      />
      <ErrorMessage
        className="custom-invalid-feedback"
        component="p"
        name={id as string}
      />
    </div>
  );
};
